module.exports = __webpack_public_path__ + "static/media/tty.44d8acb9.svg";